import React, { useEffect, useState } from 'react';
import { useTranslator } from 'tradera-lang/translate';
import useIsMobile from 'tradera-hooks/use-is-mobile';
import { DetailedRating } from './detailed-rating';
import { ItemNotReceived } from './item-not-received';
import { UnpaidItem } from './unpaid-item';
import { CommentInput } from './comment-input';
import {
    MAX_COMMENT_LENGTH,
    MIN_RATING_VALUE,
    RATING_NAMES
} from './constants';
import {
    isCommentTooLong,
    isCommentWithLinebreaks
} from './leave-feedback-helper';

export const Form = ({
    comment,
    dispatch,
    errorMessageTranslationKeys,
    isItemNotReceived,
    transactionId,
    ratingSettings,
    ratings,
    unpaidItemUrl
}) => {
    const { t } = useTranslator();
    const isMobile = useIsMobile();
    const [ratingValues, setRatingValues] = useState(Object.values(ratings));

    useEffect(() => {
        setRatingValues(Object.values(ratings));
    }, [ratings]);

    const isCommentInvalid =
        isCommentTooLong(comment) || isCommentWithLinebreaks(comment);

    const indexOfShippingTime = ratingSettings.findIndex(
        ratingSetting => ratingSetting.name === RATING_NAMES.SHIPPING_TIME
    );
    const showItemNotReceived =
        indexOfShippingTime > -1 &&
        ratingValues[indexOfShippingTime] === MIN_RATING_VALUE;

    const indexOfPaymentTime = ratingSettings.findIndex(
        ratingSetting => ratingSetting.name === RATING_NAMES.PAYMENT_TIME
    );
    const showUnpaidItem =
        indexOfPaymentTime > -1 &&
        ratingValues[indexOfPaymentTime] === MIN_RATING_VALUE;

    return (
        <>
            <div className="mt-3 px-2 px-md-0">
                <div className="d-flex justify-content-between">
                    <h5>{t('leaveFeedback_leaveComment')}</h5>
                    <span
                        className={` ${
                            isCommentInvalid ? 'text-danger' : 'text-gray-600'
                        }`}>
                        {t('leaveFeedback_charsLeft_v2', {
                            charsCount: comment.length,
                            max: MAX_COMMENT_LENGTH
                        })}
                    </span>
                </div>
                {errorMessageTranslationKeys.map(translationKey => (
                    <p key={translationKey} className="text-danger">
                        {t(translationKey)}
                    </p>
                ))}
                <CommentInput
                    value={comment}
                    dispatch={dispatch}
                    transactionId={transactionId}
                    className={isCommentInvalid ? 'is-invalid' : ''}
                />
            </div>
            <div className="row m-0 mt-3">
                {ratingSettings.map((ratingSetting, index) => {
                    return (
                        <DetailedRating
                            key={ratingSetting.name}
                            className="col-12 col-md-6 mb-2 py-2 py-md-0 px-2 px-md-0"
                            title={t(ratingSetting.titleKey)}
                            ratingDescriptions={ratingSetting.descriptionKeys.map(
                                key => t(key)
                            )}
                            selectedRating={ratingValues[index]}
                            transactionId={transactionId}
                            ratingSettingName={ratingSetting.name}
                            dispatch={dispatch}>
                            {showItemNotReceived &&
                                isMobile &&
                                indexOfShippingTime === index && (
                                    <ItemNotReceived
                                        dispatch={dispatch}
                                        isItemNotReceived={isItemNotReceived}
                                        transactionId={transactionId}
                                    />
                                )}
                            {showUnpaidItem &&
                                isMobile &&
                                indexOfPaymentTime === index && (
                                    <UnpaidItem unpaidItemUrl={unpaidItemUrl} />
                                )}
                        </DetailedRating>
                    );
                })}
            </div>
            {showItemNotReceived && !isMobile && (
                <ItemNotReceived
                    dispatch={dispatch}
                    isItemNotReceived={isItemNotReceived}
                    transactionId={transactionId}
                />
            )}
            {showUnpaidItem && !isMobile && (
                <UnpaidItem unpaidItemUrl={unpaidItemUrl} />
            )}
        </>
    );
};
